import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { createSelector } from "reselect";

const AuthProtected = ({ children, permissions }) => {
  const selectProperties = createSelector(
    (state) => state.Login,
    (login) => ({
      rolesUser: login.roles || [], // Asegurar que rolesUser siempre sea un array
      // isAdmin: login.isAdmin || false,
      permissionsUser: login.permissions || [],
    })
  );

  const { rolesUser, permissionsUser } = useSelector(selectProperties);
  // console.log(rolesUser);
  // console.log(permissionsUser);

  const isAdmin = rolesUser?.some((role) => role.name === "ENTITY_ROLE");
  // Si el usuario es admin, permitir el acceso sin importar roles
  const hasAccess =
    (isAdmin && permissions
      ? permissionsUser.some((permission: any) =>
          permissions.includes(permission.code)
        )
      : true) ||
    (permissions
      ? permissionsUser.some((permission: any) =>
          permissions.includes(permission.code)
        )
      : true);

  if (!localStorage.getItem("authUser")) {
    return <Navigate to="/login" />;
  }

  if (!hasAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AuthProtected;
